import { SituacaoNotificacaoEnum } from '../../enum/situacao-notificacao-enum';

export class NotificacaoRecepcaoRequest {
  listaNotificacoesId: number[];
  dataHoraAtualizacao: Date;
  situacao: SituacaoNotificacaoEnum;
  usuarioId: string;

  constructor() {
    this.listaNotificacoesId = [];
  }
}
